module.exports = require("core-js-pure/features/is-iterable");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/is-iterable.js
// module id = 659
// module chunks = 0 1